export default __webpack_public_path__ + "static/media/chelsea.18eca402.png";